import React, {useEffect, useRef, useState} from 'react';
import html2canvas from 'html2canvas';
import '../Components/ComponentCss/Bill.css';
import Pyo from "./Pyo";
import dojang from "../Image/dojang.png";

const Bill = ({companyName, rooms, total_amount, deposit, dataList,bigoInfo, onSaveBillAsImage}) => {
    const billRef = useRef(null);
    const [currentYear, setCurrentYear] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(null);
    const [lastDate, setLastDate] = useState(null);

    useEffect(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1; // 현재 월 (0부터 시작하므로 +1)
        const lastDay = new Date(year, month, 0).getDate(); // 이번 달의 마지막 날 계산

        setCurrentYear(year);
        setCurrentMonth(month);
        setLastDate(lastDay);
    }, []);
    // 숫자 포맷 함수
    const formatCurrency = (num) => {
        return num.toLocaleString("ko-KR");
    };

    // saveBillAsImage 함수 - 부모로 전달
    const saveBillAsImage = () => {
        const element = billRef.current;

        // billRef의 높이를 전체 콘텐츠에 맞게 설정하여 넘치는 부분을 포함시키도록 함
        const totalHeight = element.scrollHeight;

        html2canvas(element, {
            scale: 2, // 확대 배율을 높여서 화질 개선
            height: totalHeight, // 전체 높이를 포함하도록 설정
            y: 0, // 화면 상단부터 캡쳐 시작
            scrollY: -window.scrollY, // 페이지의 스크롤 위치 고려하여 캡쳐
        }).then((canvas) => {
            const image = canvas.toDataURL("image/png");
            onSaveBillAsImage(image, companyName); // 부모로 이미지 데이터를 전달
        });
    };

    // 부모로 전달
    React.useEffect(() => {
        if (onSaveBillAsImage) {
            saveBillAsImage(); // 부모 컴포넌트가 전달한 함수 실행
        }
    }, [onSaveBillAsImage]);
    const [text, setText] = useState(''); // 텍스트 상태 관리
    const textareaRef = useRef(null); // <textarea> 요소 참조

    // 텍스트 변경 시 높이 자동 조정
    const adjustHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto'; // 높이 초기화
            textarea.style.height = `${textarea.scrollHeight}px`; // 내용에 맞게 높이 조정
        }
    };

    useEffect(() => {
        adjustHeight(); // 컴포넌트가 처음 렌더링될 때 호출
    }, [text]); // 텍스트 상태 변경 시 호출

    const handleChange = (e) => {
        setText(e.target.value); // 입력 값 상태 업데이트
    };


    return (
        <div className="bill-container" ref={billRef}> {/* ref로 bill-container 참조 */}
            <div className={'bill'}>
                <div className={'top-title'}>
                    {currentYear}년 {currentMonth}월 임대료 고지서
                </div>
                <div className={'main-info-box'}>
                    <div className={'bill-info'}>
                        <div className={'bill-title'}>제목 : {currentYear}년 {currentMonth}월 보육 및 공공요금 사용내역서 안내</div>
                        <div className={'tt'}>{currentYear}.{currentMonth}.01.~{currentYear}.{currentMonth}.{lastDate}. 보육료 및 공공요금이 아래와 같이 산출되었습니다.</div>
                        <div className={'tt'}>다음 계좌로 입금하여 주시기 바랍니다.</div>
                        <div className={'account'}>입금계좌 : 농협 785-01-141856 (예금주 금오공대산학협력단)</div>
                        <div className={'company-name'}>업체명 : {companyName}</div>
                        <div className="company-use-rooms">
                            사용호실 : {rooms
                            .sort((a, b) => a - b) // 오름차순 정렬
                            .map((room) => `${room}호`) // 형식 지정
                            .join(", ")} {/* 쉼표로 구분 */}
                        </div>
                        <div className={'under'}>-- 아래 --</div>
                    </div>
                    <div className={"info-title"}>
                        <div className={'years'}>일자</div>
                        <div className={'rooms'}>호실</div>
                        <div className={'pay-info'}>
                            <div className={'pay-info-1'}>
                                <div className={'pay-element_1'}>보육료</div>
                                <div className={'pay-element-move'}></div>
                                <div className={'pay-element_1-weare'}>관리비(공공요금)</div>
                            </div>
                            <div className={'pay-info-2'}>
                                <div className={'pay-element'}>보육료</div>
                                <div className={'pay-element'}>부가세</div>
                                <div className={'pay-element'}>이동사항</div>
                                <div className={'pay-element'}>전기요금</div>
                                <div className={'pay-element-gas'}>냉난방(도시가스요금)</div>
                            </div>
                        </div>
                    </div>
                    {dataList.map((room, index) => (
                        <Pyo
                            key={index}
                            theDay={dataList[index].create_time}
                            electric={formatCurrency(dataList[index].elec_bill)}
                            gas={formatCurrency(dataList[index].gas_bill)}
                            rent={formatCurrency(dataList[index].rent)}
                            room={dataList[index].room_number}
                            surtax={formatCurrency(dataList[index].surtax)}
                            resRent={dataList[index].res_rent}
                            resSurtax={dataList[index].res_surtax}
                            resElectric={dataList[index].res_elec}
                            resGas={dataList[index].res_gas}
                        />
                    ))}
                    <div className={"Pyo-info-title"}>
                        <div className={'bill-years'}></div>
                        <div className={'bill-rooms'}></div>
                        <div className={'Pyo-pay-info'}>
                            <div className={'pay-info-2'}>
                                <div className={'pay-element'}></div>
                                <div className={'pay-element'}></div>
                                <div className={'pay-element'}></div>
                                <div className={'pay-element'}></div>
                                <div className={'pay-element-gas'}></div>
                            </div>
                        </div>
                    </div>
                    <div className={"Pyo-info-title"}>
                        <div className={'bill-years-q'}>총계</div>
                        <div className={'Pyo-pay-info'}>
                            <div className={'bill-pay-info-2'}>
                                <div className={'bill-pay-info-2-text'}>
                                    {formatCurrency(total_amount)} 원
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="bigo"

                    >
            <textarea
                ref={textareaRef}
                className="bigo-text"
                value={bigoInfo}
                onChange={handleChange}
                placeholder="여기에 텍스트를 입력하세요."
                style={{
                    width: '95%',
                    border: 'none',
                    resize: 'none',
                    outline: 'none',
                    fontSize: '16px',
                    overflow: 'hidden', // 스크롤바 숨김
                }}
            />
                    </div>
                    <div className={'security'}>
                        보증금 : {formatCurrency(deposit)}원
                    </div>
                    <div className={"bottom-box"}>
                        <img className="dojang" src={dojang} alt="See more"/>
                        <div className={'bottom-box-text'}>
                            국립금오공과대학교 창업보육센터장
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Bill;